'use client';

import React, { startTransition, useState } from 'react';
import { Tabs, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { cn } from '@/lib/utils';
import { tabTriggerVariants } from '@/components/ui/tab-trigger-variants';
import { TabOption } from '@/types/common/tab.type';
import { useProgress } from 'react-transition-progress';
interface TabComponentProps {
  tabOptions: TabOption[];
  defaultValue: string;
  onTabChange?: (value: string) => void;
  containerStyles?: string;
  tabListStyles?: string;
  triggerStyles?: string;
  activeTriggerStyles?: string;
  iconStyles?: string;
  variant?: 'default' | 'outline';
  size?: 'big' | null;
  tabsStyles?: string;
}

export const TabComponent = ({
  tabOptions,
  defaultValue,
  onTabChange,
  containerStyles,
  triggerStyles,
  tabListStyles,
  iconStyles = 'w-5 h-5',
  variant = 'default',
  size,
  tabsStyles,
}: TabComponentProps) => {
  const [selectedTab, setSelectedTab] = useState(defaultValue);

  const startProgress = useProgress();

  const handleTabChange = (value: string) => {
    setSelectedTab(value);

    startTransition(async () => {
      startProgress();
      onTabChange?.(value);
    });
  };

  return (
    <div
      className={cn(
        'w-fit inline-flex items-center relative',
        variant === 'outline' && 'border-b border-input',
        containerStyles,
      )}
    >
      <Tabs
        value={selectedTab}
        onValueChange={handleTabChange}
        className={cn(
          'flex-col items-center bg-[#f9f8ff] rounded-[0.9375rem] inline-flex relative',
          tabsStyles,
        )}
      >
        <TabsList
          className={cn(
            'items-start rounded-[0.9375rem] p-[0.3125rem] h-auto w-full flex-wrap',
            variant === 'outline'
              ? 'bg-transparent p-0 rounded-none'
              : 'bg-accent',
            tabListStyles,
          )}
        >
          {tabOptions.map((tab) => (
            <TabsTrigger
              key={tab.id}
              value={tab.id}
              className={cn('cursor-pointer',
                tabTriggerVariants({ variant, size }),
                triggerStyles,
              )}
            >
              {tab.icon &&
                (tab.iconPosition === 'left' || !tab.iconPosition) && (
                  <div className={iconStyles}>{tab.icon}</div>
                )}

              {tab.label}
              
              {tab.icon && tab.iconPosition === 'right' && (
                <div className={iconStyles}>{tab.icon}</div>
              )}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  );
};
